import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { Validator, AbstractControl } from '@angular/forms';


@Directive({
    selector: '[validateScreenName][formControlName], [validateScreenName][formControl],[validateScreenName][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ScreenNameValidator), multi: true }
    ]
})
export class ScreenNameValidator implements Validator {

    constructor() {
    }

    validate(c: AbstractControl) {
        if (c.value != null && c.value.length === 0) {
            return {
                validateScreenName: {
                    valid: true
                }
            };
        }
        if (c.value != null && c.value.length < 4) {
            return {
                validateScreenName: {
                    valid: false
                }
            };
        }
        let INITAL_REGEXP = /^[a-zA-Z0-9]{1}/;
        let END_REGEXP = /[a-zA-Z0-9]$/;
        let REGEXP = /^[a-zA-Z0-9]+([a-zA-Z0-9_\-.])+[a-zA-Z0-9]$/;
        return INITAL_REGEXP.test(c.value) && END_REGEXP.test(c.value) && REGEXP.test(c.value) ? null : {
            validateScreenName: {
                valid: false
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/directives/screenname-validator.ts